const style = {
  container: {
      width: "100%",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      background: "#181a20",
      color: "#FFF",
      padding: "30px 80px",
      boxSizing: "border-box",
  },
  chatWrapper: {
      width: "100%",
      maxWidth: "800px",
      margin: "0 auto",
      height: "100%",
      display: "flex",
      flexDirection: "column",
  },
  chatHistory: {
      flexGrow: 1,
      overflowY: "auto",
      padding: '0 20px',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
  },
  welcomeSection: {
      textAlign: "center",
      margin: "auto 0",
  },
  logo: {
      fontSize: "48px",
      marginBottom: "20px",
  },
  title: {
      fontSize: "28px",
      fontWeight: "600",
      color: "#FFF",
      marginBottom: '40px',
  },
  suggestionsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "15px",
  },
  suggestionCard: {
      background: "#1e212b",
      border: "1px solid #2a2f3b",
      borderRadius: "12px",
      padding: "20px",
      cursor: "pointer",
      transition: "background 0.2s ease, transform 0.2s ease",
      display: "flex",
      flexDirection: "column",
      justifyContent: 'space-between',
      height: '120px',
  },
  cardIcon: {
      color: '#aeb9c4',
      alignSelf: 'flex-end'
  },
  cardText: {
      color: '#FFF',
      fontSize: '15px',
      margin: 0,
      fontWeight: '500',
      textAlign: 'left'
  },
  inputArea: {
      paddingTop: "20px",
      flexShrink: 0,
  },
  inputWrapper: {
      position: "relative",
      width: "100%",
  },
  textInput: {
      width: "100%",
      height: "55px",
      background: "#2a2f3b",
      border: "1px solid #3c4257",
      borderRadius: "15px",
      padding: "15px 60px 15px 20px",
      boxSizing: "border-box",
      color: "#FFF",
      fontSize: "16px",
      outline: "none",
      resize: "none",
  },
  sendButton: {
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      background: "#4ecf78",
      color: '#1e212b',
      border: "none",
      width: "40px",
      height: "40px",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
  },
  disabledButton: {
      opacity: 0.5,
      cursor: 'not-allowed',
  },
  disclaimer: {
      fontSize: '12px',
      color: '#aeb9c4',
      textAlign: 'center',
      marginTop: '15px'
  },
  userMessage: {
      alignSelf: 'flex-end',
      maxWidth: '80%',
  },
  aiMessage: {
      alignSelf: 'flex-start',
      maxWidth: '80%',
  },
  messageContent: {
      background: '#2a2f3b',
      borderRadius: '15px',
      padding: '10px 15px',
  },
  senderName: {
      fontWeight: '600',
      fontSize: '14px',
      marginBottom: '5px',
      display: 'block',
      color: '#4ecf78',
  },
  messageText: {
      margin: 0,
      fontSize: '15px',
      whiteSpace: 'pre-wrap',
      color: '#e0e0e0',
  },
  loadingIndicator: {
      display: 'flex',
      alignItems: 'center',
      padding: '10px 15px',
      background: '#2a2f3b',
      borderRadius: '15px',
      width: 'fit-content'
  },
  'loadingIndicator span': {
      height: '8px',
      width: '8px',
      background: '#aeb9c4',
      borderRadius: '50%',
      margin: '0 3px',
      animation: 'bounce 1.4s infinite ease-in-out both'
  },
};

// Keyframes need to be injected globally or handled differently in JS-in-CSS
const keyframes = `
@keyframes bounce {
0%, 80%, 100% { transform: scale(0); }
40% { transform: scale(1.0); }
}
`;
const styleSheet = document.styleSheets[0];
try {
  styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
  styleSheet.insertRule(`${'#root'} .loading-indicator span:nth-child(1) { animation-delay: -0.32s; }`, styleSheet.cssRules.length);
  styleSheet.insertRule(`${'#root'} .loading-indicator span:nth-child(2) { animation-delay: -0.16s; }`, styleSheet.cssRules.length);
} catch (e) {
  console.warn("Could not insert CSS keyframes.", e);
}


style['loadingIndicator span:nth-child(1)'] = { animationDelay: '-0.32s' };
style['loadingIndicator span:nth-child(2)'] = { animationDelay: '-0.16s' };

export default style;